import { connect } from 'react-redux';
import { ChangePayMethodContainer, PaymentScheduleEditButton } from '../styles';
import {
  setFundingInstruments,
  setPaymentInstrument,
} from '../../make-payment/step-two-amount/makePaymentStepTwoReducer';
import React from 'react';
import PropTypes from 'prop-types';

export const ChangePayMethod = (props) => {
  const {
    dispatch,
    account,
    showEditPaymentMethod,
    setShowEditPaymentMethod,
    setShowEditPaymentSchedule,
    initialState,
  } = props;
  return (
    <ChangePayMethodContainer>
      Need to change your Payment Method?{' '}
      <PaymentScheduleEditButton
        id="editPayMethod"
        onClick={() => {
          dispatch(setPaymentInstrument(null)); //reset if user has already clicked on set pay schedule
          dispatch(setFundingInstruments([]));
          setShowEditPaymentSchedule(initialState); // reset edit schedule just show payment method
          setShowEditPaymentMethod({
            ...showEditPaymentMethod,
            [account.id]: !showEditPaymentMethod[account.id],
          });
        }}
      >
        Click Here
      </PaymentScheduleEditButton>
    </ChangePayMethodContainer>
  );
};
ChangePayMethod.propTypes = {
  dispatch: PropTypes.func,
  account: PropTypes.object,
  showEditPaymentMethod: PropTypes.object,
  setShowEditPaymentMethod: PropTypes.func,
  initialState: PropTypes.object,
  setShowEditPaymentSchedule: PropTypes.func,
};
export default connect()(ChangePayMethod);